const colors = {
    black: '#000000',
    color1: '#222222',
    color2: '#951B81',
    color3: '#CFA22E',
    darkGray: '#454545',
    basketGray: '#676C6E',
    darkerGray: '#262626',
    green: '#951B81',
    lightGreen: 'rgba(0, 204, 106, 0.5)',
    header: '#F8F8F8',
    lightGray: '#F3F0F0',
    midGray: '#676C6E',
    warning: '#EB5757',
    lightWarning: 'rgba(235, 87, 87, 0.20)',
    white: '#FFFFFF',
    basketInfoIcon: 'rgba(34, 34, 34, 0.54)',
    buttonPrimaryColor: '#951B81',
    violet: '#951B81',
}

export default colors
